import { render, staticRenderFns } from "./partnerCount.vue?vue&type=template&id=52acc990&"
import script from "./partnerCount.vue?vue&type=script&lang=js&"
export * from "./partnerCount.vue?vue&type=script&lang=js&"
import style0 from "./partnerCount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "partnerCount.vue"
export default component.exports